





















export default {
  name: "flows-icon",
  props: {
    title: {
      type: String,
      default: "Flows icon"
    },
    decorative: {
      type: Boolean,
      default: false
    }
  }
}
